import React, { Component, } from 'react';
import { bool, } from 'prop-types';
// import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

export default function ClickToHideHOC(WrappedComponent) {
  return class ClickToHide extends Component {
    static propTypes = {
      transition: bool,
    }
    static defaultProps = {
      transition: false,
    }
    constructor(props) {
      super(props);
      this.state = {
        isHidden: false,
      };
      this.hideComponent = this.hideComponent.bind(this);
    }
    hideComponent() {
      this.setState({
        isHidden: true,
      });
    }
    render() {
      // if (this.props.transition) {
      //   return (<ReactCSSTransitionGroup
      //     transitionName="slide-300"
      //     transitionEnterTimeout={ 300 }
      //     transitionLeaveTimeout={ 300 }
      //   >
      //     {
      //       this.state.isHidden
      //       ? null
      //       : <WrappedComponent
      //         { ...this.props }
      //         handleHideComponent={ this.hideComponent }
      //       />
      //     }
      //   </ReactCSSTransitionGroup>);
      // }
      if (this.state.isHidden) return null;
      return (<WrappedComponent
        { ...this.props }
        handleHideComponent={ this.hideComponent }
      />);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/hoc/clickToHideHOC.js